import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://localhost:7008/api";

const portalApiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

portalApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("portalToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

portalApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname.startsWith("/portal")) {
      localStorage.removeItem("portalToken");
      localStorage.removeItem("portalUser");
      if (!window.location.pathname.startsWith("/portal/login")) {
        window.location.href = "/portal/login";
      }
    }
    return Promise.reject(error);
  }
);

export default portalApiClient;
